import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { withStyles, withTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Dialog from "@material-ui/core/Dialog";
import classNames from "classnames";
import { taxServiceClient } from "../AxiosClient";
import TreeComponent from "./../components/taxonomy/TreeComponent";
import TopicAutosuggest from "./../components/taxonomy/TopicAutosuggest";
import TeamAutosuggest from "./../components/taxonomy/TeamAutosuggest";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { AutoSizer } from "react-virtualized";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Popper from "@material-ui/core/Popper";
import Paper from "@material-ui/core/Paper";
import SvgIcon from "@material-ui/core/SvgIcon";
import MenuItem from "@material-ui/core/MenuItem";
import CloseIcon from "@material-ui/icons/Close";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import CancelIcon from "@material-ui/icons/Cancel";
import CreateKnowledgeSource from "./knowledgesource/CreateKnowledgeSource";
import Menu from "@material-ui/core/Menu";
import Alert from "@material-ui/lab/Alert";
import i18n from "i18next";
import { Trans, withTranslation, initReactI18next } from "react-i18next";

import FilterableList from "./components/FilterableList.js";
import OrganizationEditor from "./components/OrganizationEditor.js";
import CreateOrganizationDialog from "./components/CreateOrganizationDialog.js";
import AddUserDialog from "./AddUserDialog";
import Tooltip from "@material-ui/core/Tooltip";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { withRouter } from "react-router-dom";

const TAXONOMY = "taxonomy";
const TEAM = "team";
const TOPIC = "topic";
const ORGANIZATION = "organization";
const drawerWidth = 400;
const teamSVG =
  "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z";
const userSVG =
  "M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z";
const taxonomySVG =
  "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z";
const topicSVG =
  "M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M4,9V12C4,14.21 7.58,16 12,16C16.42,16 20,14.21 20,12V9C20,11.21 16.42,13 12,13C7.58,13 4,11.21 4,9M4,14V17C4,19.21 7.58,21 12,21C16.42,21 20,19.21 20,17V14C20,16.21 16.42,18 12,18C7.58,18 4,16.21 4,14Z";
const organizationSVG =
  "M18,15H16V17H18M18,11H16V13H18M20,19H12V17H14V15H12V13H14V11H12V9H20M10,7H8V5H10M10,11H8V9H10M10,15H8V13H10M10,19H8V17H10M6,7H4V5H6M6,11H4V9H6M6,15H4V13H6M6,19H4V17H6M12,7V3H2V21H22V7H12Z";
const landscapeSVG =
  "M9,1H3A2,2 0 0,0 1,3V16A2,2 0 0,0 3,18H9A2,2 0 0,0 11,16V3A2,2 0 0,0 9,1M9,15H3V3H9V15M21,13H13V15H21V21H9V20H6V21A2,2 0 0,0 8,23H21A2,2 0 0,0 23,21V15A2,2 0 0,0 21,13M23,10L19,8L20.91,7.09C19.74,4.31 17,2.5 14,2.5V1A9,9 0 0,1 23,10Z";
const portraitSVG =
  "M9,1H3A2,2 0 0,0 1,3V16A2,2 0 0,0 3,18H4V15H3V3H9V11H11V3A2,2 0 0,0 9,1M23,21V15A2,2 0 0,0 21,13H8A2,2 0 0,0 6,15V21A2,2 0 0,0 8,23H21A2,2 0 0,0 23,21M9,21V15H21V21H9M23,10H21.5C21.5,7 19.69,4.27 16.92,3.09L16,5L14,1A9,9 0 0,1 23,10Z";
const defaultSVG =
  "M15.07,11.25L14.17,12.17C13.45,12.89 13,13.5 13,15H11V14.5C11,13.39 11.45,12.39 12.17,11.67L13.41,10.41C13.78,10.05 14,9.55 14,9C14,7.89 13.1,7 12,7A2,2 0 0,0 10,9H8A4,4 0 0,1 12,5A4,4 0 0,1 16,9C16,9.88 15.64,10.67 15.07,11.25M13,19H11V17H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z";
const unlinkSVG =
  "M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.43 19.12,14.63 17.79,15L19.25,16.44C20.88,15.61 22,13.95 22,12A5,5 0 0,0 17,7M16,11H13.81L15.81,13H16V11M2,4.27L5.11,7.38C3.29,8.12 2,9.91 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12C3.9,10.41 5.11,9.1 6.66,8.93L8.73,11H8V13H10.73L13,15.27V17H14.73L18.74,21L20,19.74L3.27,3L2,4.27Z";
const collapseLevel1SVG =
  "M19.5,3.09L20.91,4.5L16.41,9H20V11H13V4H15V7.59L19.5,3.09M20.91,19.5L19.5,20.91L15,16.41V20H13V13H20V15H16.41L20.91,19.5M4.5,3.09L9,7.59V4H11V11H4V9H7.59L3.09,4.5L4.5,3.09M3.09,19.5L7.59,15H4V13H11V20H9V16.41L4.5,20.91L3.09,19.5Z";
const expandAllSVG =
  "M9.5,13.09L10.91,14.5L6.41,19H10V21H3V14H5V17.59L9.5,13.09M10.91,9.5L9.5,10.91L5,6.41V10H3V3H10V5H6.41L10.91,9.5M14.5,13.09L19,17.59V14H21V21H14V19H17.59L13.09,14.5L14.5,13.09M13.09,9.5L17.59,5H14V3H21V10H19V6.41L14.5,10.91L13.09,9.5Z";
const sourceSVG =
  "M12,3C8.59,3 5.69,4.07 4.54,5.57L9.79,10.82C10.5,10.93 11.22,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M3.92,7.08L2.5,8.5L5,11H0V13H5L2.5,15.5L3.92,16.92L8.84,12M20,9C20,11.21 16.42,13 12,13C11.34,13 10.7,12.95 10.09,12.87L7.62,15.34C8.88,15.75 10.38,16 12,16C16.42,16 20,14.21 20,12M20,14C20,16.21 16.42,18 12,18C9.72,18 7.67,17.5 6.21,16.75L4.53,18.43C5.68,19.93 8.59,21 12,21C16.42,21 20,19.21 20,17";
const styles = (theme) => ({
  // const styles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1),
  },
  input: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    height: "100%",
    overflow: "visible",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    position: "relative",
    overflowX: "hidden",
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(8) + 1,
    "& #sidebarContent": {
      display: "none",
    },
    position: "relative",
  },
  pageContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
  },
  sidebarContainer: {
    display: "flex",
    overflow: "hidden",
  },
  treeContainer: {
    flex: 70,
    borderRight: "1px solid rgba(0, 0, 0, 0.12)",
    borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
    height: "100%",
  },
  sidebarIcon: {
    width: theme.spacing(6),
  },
  expansionPanel: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    flexDirection: "column",
    // marginLeft: theme.spacing(6),
  },
  cardContent: {
    // marginLeft: theme.spacing(6),
  },
  popper: {
    zIndex: 12000,
    marginTop: 7,
    // maxWidth: '30%',
    '&[x-placement*="left"] $arrow': {
      top: 15,
      right: 0,
      marginLeft: "-0.9em",
      width: "1em",
      height: "3em",
      "&::before": {
        borderWidth: "1em 1em 1em 0",
        borderColor: `transparent ${
          theme.palette.common.white
        } transparent transparent`,
      },
    },
    '&[x-placement*="right"] $arrow': {
      top: 15,
      right: 0,
      marginLeft: "-0.9em",
      width: "1em",
      height: "3em",
      "&::before": {
        borderWidth: "1em 0 1em 1em",
        borderColor: `transparent transparent transparent ${
          theme.palette.common.white
        }`,
      },
    },
    '&[x-placement*="right-start"] $arrow': {
      top: 8,
      right: 0,
      marginLeft: "-0.9em",
      width: "1em",
      height: "3em",
      "&::before": {
        borderWidth: "1em 0 1em 1em",
        borderColor: `transparent transparent transparent ${
          theme.palette.common.white
        }`,
      },
    },
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginLeft: "-0.9em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "0 1em 1em 1em",
        borderColor: `transparent transparent ${
          theme.palette.common.white
        } transparent`,
      },
    },
    '&[x-placement*="top"] $arrow': {
      left: 0,
      bottom: 0,
      marginLeft: "-0.9em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "1em 1em 0 1em",
        borderColor: `${
          theme.palette.common.white
        } transparent transparent transparent`,
      },
    },
  },
  arrow: {
    position: "absolute",
    fontSize: 7,
    width: "3em",
    height: "3em",
    "&::before": {
      content: '""',
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid",
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  dialogTitle: {
    marginRight: theme.spacing(6),
  },
  panelSummaryIcon: {
    marginRight: theme.spacing(1),
  },
  heading: {
    marginTop: 1,
  },
  orgContainer: {
    display: "block",
    width: "100%",
  },
  addOrg: {
    width: "100%",
    textAlign: "right",
  },
  dragItemContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: -1,
    background: "transparent",
    height: 24,
    opacity: 1,
    display: "flex",
  },
  dragItem: {
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: -1,
    background: "transparent",
    height: 24,
    // width: "100%",
    opacity: 1,
    display: "flex",
    whiteSpace: "nowrap",
  },
  dragItemName: {
    marginLeft: theme.spacing(1),
  },
  userRoleIcon: {
    margin: theme.spacing(1),
    display: "flex",
  },
  unlinkIcon: {
    marginLeft: theme.spacing(0.1),
    marginRight: theme.spacing(0.5),
    backgroundColor: theme.palette.grey[400],
  },
  green: {
    color: theme.palette.success.main,
  },
  tableCellSmall: {
    padding: 0,
    "&:last-child": {
      padding: 0,
    },
  },
  unlinkShortcut: {
    marginTop: theme.spacing(1),
  },
  classificationCtr: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  roleCtr: {
    display: "flex",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
});

export class TaxonomyMaintenance extends Component {
  // itemRef = React.createRef();
  constructor(props) {
    super(props);
    this.dragRef = React.createRef();
    this.state = {
      topicColourTheme: `${this.props.theme.palette.primary.dark}`,
      teamColourTheme: `${this.props.theme.palette.secondary.dark}`,
      taxonomyColourTheme: `${this.props.theme.palette.primary.light}`,
      organizationColourTheme: "black",
      disabledColourTheme: `${this.props.theme.palette.text.disabled}`,
      dataurl: "/taxonomy/fulltree",
      organizationsurl: "/organization/",
      showTeam: true,
      showTopic: true,
      margin: { top: 20, right: 120, bottom: 20, left: 120 },
      width: 720,
      height: 640,
      sidebarOpen: false,
      expandedPanel: "",
      nodeData: null,
      landscape: true,
      dropDialogOpen: false,
      dragTarget: null,
      dragItem: null,
      selectedItem: null,
      filterValue: null,
      treeStart: null,
      data: null,
      orgdata: [],
      organization: null,
      setLevel: false,
      setExpanded: false,
      classifications: [
        {
          value: -1,
          label: "No Access",
        },
        {
          value: 0,
          label: "Default",
        },
        {
          value: 1,
          label: "Level 1",
        },
        {
          value: 2,
          label: "Level 2",
        },
        {
          value: 3,
          label: "Level 3",
        },
        {
          value: 4,
          label: "Level 4",
        },
        {
          value: 5,
          label: "Level 5",
        },
      ],
      arrowRef: null,
      anchorEl: null,
      createOrganizationDialogOpen: false,
      drawerDialogOpen: false,
      addItem: null,
      drawerDialogAnchor: null,
      topicNeedsUpdate: false,
      teamNeedsUpdate: false,
      organizationNeedsUpdate: false,
      isDragging: false,
      draggingNode: null,
      dragOrigin: null,
      dragTarget: null,
      userNeedsUpdate: false,
      numTeamUsers: 0,
      beExpert:
        "M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18Z",
      reviewer:
        "M20,2H4A2,2 0 0,0 2,4V16A2,2 0 0,0 4,18H8L12,22L16,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M12,4.3C13.5,4.3 14.7,5.5 14.7,7C14.7,8.5 13.5,9.7 12,9.7C10.5,9.7 9.3,8.5 9.3,7C9.3,5.5 10.5,4.3 12,4.3M18,15H6V14.1C6,12.1 10,11 12,11C14,11 18,12.1 18,14.1V15Z",
      approver:
        "M21.1,12.5L22.5,13.91L15.97,20.5L12.5,17L13.9,15.59L15.97,17.67L21.1,12.5M10,17L13,20H3V18C3,15.79 6.58,14 11,14L12.89,14.11L10,17M11,4A4,4 0 0,1 15,8A4,4 0 0,1 11,12A4,4 0 0,1 7,8A4,4 0 0,1 11,4Z",
      publisher:
        "M17,21L14.25,18L15.41,16.84L17,18.43L20.59,14.84L21.75,16.25M12.8,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19A2,2 0 0,1 21,5V12.8C20.12,12.29 19.09,12 18,12L17,12.08V11H7V13H14.69C13.07,14.07 12,15.91 12,18C12,19.09 12.29,20.12 12.8,21M12,15H7V17H12M17,7H7V9H17",
      moderator:
        "M18,19H6V17.6C6,15.6 10,14.5 12,14.5C14,14.5 18,15.6 18,17.6M12,7A3,3 0 0,1 15,10A3,3 0 0,1 12,13A3,3 0 0,1 9,10A3,3 0 0,1 12,7M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z",
      forumModerator:
        "M20,17A2,2 0 0,0 22,15V4A2,2 0 0,0 20,2H9.46C9.81,2.61 10,3.3 10,4H20V15H11V17M15,7V9H9V22H7V16H5V22H3V14H1.5V9A2,2 0 0,1 3.5,7H15M8,4A2,2 0 0,1 6,6A2,2 0 0,1 4,4A2,2 0 0,1 6,2A2,2 0 0,1 8,4Z",
      copiedData: null,
      childrenOnly: false,
      addUserDialogOpen: false,
      numKnowledgeSources: 0,
      showSources: false,
      sourceNeedsUpdate: false,
      addSourceDialogOpen: false,
      selectedItemMenu: false,
      nodeDataTarget: null,
      treeState: [],
      confirmDialogOpen: false,
      deleteUrl: "",
      selectedSource: null,
    };

    this.dragDropAction = this.dragDropAction.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.onItemSelected = this.onItemSelected.bind(this);
    this.unlinkFromTree = this.unlinkFromTree.bind(this);
    this.setTreeStart = this.setTreeStart.bind(this);
    this.resetTreeStart = this.resetTreeStart.bind(this);
    this.unsetLevel = this.unsetLevel.bind(this);
    this.unsetExpanded = this.unsetExpanded.bind(this);
    this.getOrganizations = this.getOrganizations.bind(this);
    this.organizationSelected = this.organizationSelected.bind(this);
    this.dragStart = this.dragStart.bind(this);
    this.updateTreeState = this.updateTreeState.bind(this);
  }

  componentDidMount() {
    i18n.use(initReactI18next);
    this.getOrganizations();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.treeStart !== null) {
      if (!prevState.treeStart) {
        this.getData();
      } else {
        if (this.state.treeStart.id !== prevState.treeStart.id) {
          this.getData();
        }
      }
    } else if (prevState.treeStart !== null && this.state.treeStart === null) {
      this.getData();
    } else if (this.state.organization !== null) {
      if (
        prevState.organization === null ||
        prevState.organization.organizationId !==
          this.state.organization.organizationId
      ) {
        this.getData();
      }
    }
  }

  handleArrowRef = (node) => {
    this.setState({
      arrowRef: node,
    });
  };

  nodeClicked = (d) => {
    d.data.taxonomyName = d.parent ? d.parent.data.name : "";
    d.data.taxonomyId = d.parent ? d.parent.data.id : "";
    this.setState({
      sidebarOpen: true,
      expandedPanel: "selectionDetails",
      nodeData: d.data,
      nodeDataTarget: d,
      userNeedsUpdate: d.data.type === TEAM ? true : false,
      sourceNeedsUpdate: d.data.type === TOPIC ? true : false,
    });
  };
  closeSidebar = () => {
    this.setState({ sidebarOpen: false, nodeData: null });
  };
  toggleSidebar = () => {
    this.setState((prev) => ({ sidebarOpen: !prev.sidebarOpen }));
  };
  handlePanelChange = (panel) => (event, expanded) => {
    this.setState({ expandedPanel: expanded ? panel : false });
  };
  getOrganizations = () => {
    if (this.props.currentUser.isOperator === 1) {
      let url = this.state.organizationsurl;
      taxServiceClient
        .get(url)
        .then((res) => {
          //NB FilterableList gets organization separately
          this.setState(
            { orgdata: res.data.content, organizationNeedsUpdate: true },
            () => {
              this.state.orgdata.length === 1
                ? this.setState({ organization: this.state.orgdata[0] })
                : this.setState({
                    sidebarOpen: true,
                    expandedPanel: "organizationSelection",
                  });
            }
          );
        })
        .catch((err) => {
          // ignore, probably a forbidden
        });
    } else {
      this.setState({ organization: this.props.currentUser.organization });
    }
  };

  getData = () => {
    let url = this.state.treeStart
      ? this.state.dataurl + "?startId=" + this.state.treeStart.id
      : this.state.dataurl;

    if (this.state.organization !== null) {
      url.indexOf("?") === -1
        ? (url =
            url + "?orgId=" + escape(this.state.organization.organizationId))
        : (url =
            url + "&orgId=" + escape(this.state.organization.organizationId));
    }

    taxServiceClient
      .get(url)
      .then((res) => {
        //setting treeState here expands the first level under root as a minimum
        this.setState({
          data: res.data,
          treeState: this.state.treeState.concat(
            [res.data.id].filter((c) => this.state.treeState.indexOf(c) === -1)
          ),
        });
      })
      .catch((err) => {
        // alert("error");
      });
  };

  updateData = (url, obj) => {
    taxServiceClient
      .patch(url, obj)
      .then((res) => {
        //this.getData()
      })
      .catch((err) => {
        // alert("error");
      });
  };
  postData = (url, obj, fn) => {
    taxServiceClient
      .post(url, obj)
      .then((res) => {
        fn ? fn(this.getIdForItem(res.data)) : this.getData();
      })
      .catch((err) => {
        //alert("error:" + err);
      });
  };
  getIdForItem = (obj) => {
    if (obj.hasOwnProperty("teamId")) {
      return obj.teamId;
    }
    if (obj.hasOwnProperty("taxonomyId")) {
      return obj.taxonomyId;
    }
    if (obj.hasOwnProperty("topicId")) {
      return obj.topicId;
    }
    return -1;
  };
  deleteData = (url) => {
    this.setState({ confirmDialogOpen: true, deleteUrl: url });
  };

  confirmDeleteData = () => {
    taxServiceClient
      .delete(this.state.deleteUrl)
      .then((res) => {
        this.setState({ sidebarOpen: false, nodeData: null });
        this.getData();
      })
      .catch((err) => {
        alert("error");
      });
    this.setState({ confirmDialogOpen: false, deleteUrl: "" });
  };

  dragDropAction(d, dragTarget) {
    const id = d.data ? d.data.id : d.id;
    const type = d.data ? d.data.type : d.type;
    if (dragTarget.data.type === TAXONOMY) {
      if (!d.data && d.id === "-1") {
        // A new Node is being added
        this.setState({
          isDragging: false,
          dropDialogOpen: true,
          dragTarget: dragTarget,
          dragItem: d,
        });
      } else if (dragTarget.data.id !== id || type !== TAXONOMY) {
        this.handleDrop(dragTarget.data.id, d.data ? d.data : d, d);
      }
    }
  }
  handleDrop(parentId, data, d) {
    let type = data.type;
    let url = "/taxonomy/" + parentId;
    let attached = data.object
      ? data.object
      : {
          [type === TAXONOMY
            ? "taxonomyId"
            : type === TEAM
              ? "teamId"
              : "topicId"]: data.id,
        };
    if (type === TAXONOMY) {
      attached.childId = data.id;
    }
    const parentIdProp = type === TAXONOMY ? "parentId" : "taxonomyId";
    attached[parentIdProp] = data.object ? data.object[parentIdProp] : parentId;
    let newData = data;
    newData.object = attached;
    newData.taxonomyId = parentId;
    newData.taxonomyName = this.state.dragTarget.data.name;
    url +=
      type === TAXONOMY
        ? "/taxonomy/"
        : type === TEAM
          ? "/team/"
          : type === TOPIC && "/topic/";

    this.postData(url, attached, (attached) => {
      this.setState({
        topicNeedsUpdate: type === TOPIC ? true : false,
        teamNeedsUpdate: type === TEAM ? true : false,
        nodeData: newData,
        nodeDataTarget: this.state.dragTarget,
        treeState: this.state.treeState.concat(
          [newData.taxonomyId].filter(
            (c) => this.state.treeState.indexOf(c) === -1
          )
        ),
      });
      this.getData();
    });
  }
  handleNodeDataChange(key, value) {
    let newNodeData = this.state.nodeData;
    newNodeData.object[key] = value;
    this.setState({
      nodeData: {
        ...this.state.nodeData,
        object: { ...this.state.nodeData.object, [key]: value },
      },
    });
    let updateTeamUrl =
      "/taxonomy/" +
      newNodeData.object.taxonomyId +
      "/team/" +
      newNodeData.object.teamId;
    this.updateData(updateTeamUrl, newNodeData.object);
  }
  handleDataChange(name, value) {
    const type = this.state.nodeData.type;
    this.setState({
      nodeData: { ...this.state.nodeData, [name]: value },
      topicNeedsUpdate: type === TOPIC || type === ORGANIZATION ? true : false,
      teamNeedsUpdate: type === TEAM || type === ORGANIZATION ? true : false,
      organizationNeedsUpdate: type === ORGANIZATION ? true : false,
    });
    const d = this.dtoFromNodeData(name, value);
    let updateUrl = "";
    updateUrl +=
      type === TEAM
        ? "/team/"
        : type === TOPIC
          ? "/topic/"
          : type === TAXONOMY
            ? "/taxonomy/"
            : type === ORGANIZATION && "/organization/";
    updateUrl += d.id;
    this.updateData(updateUrl, d);
  }
  dtoFromNodeData(name, value) {
    // our nodeData object can come from a node type attached to a taxonomy
    // so is not a natural match to the data we want to save - create an
    // object matching the corresponding DTO
    let dto = {};
    let myObject = this.state.nodeData.object;
    myObject
      ? myObject["topicId"]
        ? (dto.id = myObject.topicId)
        : myObject["teamId"]
          ? (dto.id = myObject.teamId)
          : myObject["taxonomyId"]
            ? (dto.id = myObject.taxonomyId)
            : (dto.id = this.state.nodeData.id)
      : (dto.id = this.state.nodeData.id);

    dto[this.state.nodeData.type + "Name"] = value;
    return dto;
  }
  handleDrawerDialogClose = () => {
    this.setState({
      drawerDialogOpen: false,
      addItem: null,
    });
  };
  handleDrawerDialogSubmit = () => {
    let url = "";
    const type = this.state.addItem.type;
    url +=
      type === TEAM
        ? "/team/"
        : type === TOPIC
          ? "/topic/"
          : type === TAXONOMY && "/taxonomy/";
    url +=
      this.state.organization !== null
        ? "?orgId=" + escape(this.state.organization.organizationId)
        : "";
    let obj = {};
    obj[type + "Name"] = this.state.filterValue;
    this.postData(url, obj, () => {
      this.setState({
        drawerDialogOpen: false,
        topicNeedsUpdate:
          this.state.addItem.type === TOPIC ||
          this.state.addItem.type === ORGANIZATION
            ? true
            : false,
        teamNeedsUpdate:
          this.state.addItem.type === TEAM ||
          this.state.addItem.type === ORGANIZATION
            ? true
            : false,
        organizationNeedsUpdate:
          this.state.addItem.type === ORGANIZATION ? true : false,
        addItem: null,
      });
      this.getData();
    });
  };

  handleDropDialogClose = () => {
    this.setState({
      dropDialogOpen: false,
      dragTarget: null,
      anchorEl: null,
      dragItem: null,
      isDragging: false,
      draggingNode: null,
      dragOrigin: null,
      dragTarget: null,
    });
  };
  attachItem = (taxonomyId, type, childId) => {
    let url = "/taxonomy/" + taxonomyId;
    url +=
      type === TEAM
        ? "/team/"
        : type === TOPIC
          ? "/topic/"
          : type === TAXONOMY && "/taxonomy/";
    let attached = {};
    if (type !== TAXONOMY) {
      attached[type + "Id"] = childId;
      attached.taxonomyId = taxonomyId;
    } else {
      attached.childId = childId;
      attached.parentId = taxonomyId;
    }
    this.postData(url, attached);
  };
  handleDropDialogSubmit = () => {
    if (this.state.dragTarget !== null && this.state.dragItem !== null) {
      if (this.state.selectedItem !== null || this.state.dragItem.id !== "-1") {
        if (
          this.state.dragItem.type !== TAXONOMY ||
          (this.state.dragItem.type === TAXONOMY &&
            this.state.dragTarget.data.id !==
              this.getIdForItem(this.state.selectedItem))
        ) {
          this.attachItem(
            this.state.dragTarget.data.id,
            this.state.dragItem.type,
            this.getIdForItem(this.state.selectedItem)
          );
        }
      } else if (this.state.filterValue !== null) {
        let url = "";
        const type = this.state.dragItem.type;
        const targetId = this.state.dragTarget.data.id;
        url +=
          type === TEAM
            ? "/team/"
            : type === TOPIC
              ? "/topic/"
              : type === TAXONOMY && "/taxonomy/";
        url +=
          this.state.organization !== null
            ? "?orgId=" + escape(this.state.organization.organizationId)
            : "";
        let obj = {};
        // if (type !== TAXONOMY) {
        obj[type + "Name"] = this.state.filterValue;
        // }
        this.postData(
          url,
          obj,
          function(childId) {
            this.attachItem(targetId, type, childId);
            this.setState({
              topicNeedsUpdate: type === TOPIC ? true : false,
              teamNeedsUpdate: type === TEAM ? true : false,
            });
          }.bind(this)
        );
      }
    }

    this.setState({
      dropDialogOpen: false,
      dragTarget: null,
      anchorEl: null,
      dragItem: null,
      selectedItem: null,
      filterValue: null,
    });
  };
  onFilterChange = (newValue) => {
    this.setState({
      filterValue: newValue.trim().length > 0 ? newValue : null,
    });
  };
  onTextChange = (evt) => {
    this.setState({
      filterValue: evt.target.value.trim().length > 0 ? evt.target.value : null,
    });
  };
  onItemSelected = (selectedItem) => {
    this.setState({ selectedItem: selectedItem });
  };
  unlinkFromTreeForContextMenu = (targetData) => {
    let d = { ...targetData };
    d.data.taxonomyName = d.parent ? d.parent.data.name : "";
    d.data.taxonomyId = d.parent ? d.parent.data.id : "";
    this.setState(
      {
        nodeData: d.data,
      },
      () => this.unlinkFromTree()
    );
  };
  unlinkFromTree() {
    const baseUrl = "/taxonomy/";
    const d = this.state.nodeData;

    const type = this.state.nodeData.type;
    const taxonomyId =
      type === "taxonomy" ? d.id : d.taxonomyId ? d.taxonomyId : d.id;
    let updateUrl = baseUrl + taxonomyId;

    updateUrl +=
      type === TEAM
        ? "/team/" + d.object.teamId
        : type === TOPIC
          ? "/topic/" + d.object.topicId
          : "";
    this.deleteData(updateUrl);
  }
  changeTreeStart = (nodeData) => {
    //called from tree component contextmenu
    nodeData !== null
      ? this.setState(
          {
            nodeData: nodeData,
          },
          () => {
            this.setTreeStart();
          }
        )
      : this.resetTreeStart();
  };
  setTreeStart = () => {
    this.setState({ treeStart: this.state.nodeData, selectedItemMenu: false });
  };
  resetTreeStart = () => {
    this.setState({ treeStart: null, selectedItemMenu: false });
  };
  removeSelectedFromTree = () => {
    const url =
      "taxonomy/" +
      this.state.nodeData.type +
      "/" +
      this.state.nodeData.object[this.state.nodeData.type + "Id"];
    this.deleteData(url);
    this.setState({ selectedItemMenu: false });
  };
  removeFromTree = (nodeData) => {
    let url =
      "taxonomy/" + nodeData.type + "/" + nodeData.object[nodeData.type + "Id"];
    this.deleteData(url);
  };
  removeSelectedChildren = () => {
    this.state.nodeData.hasOwnProperty("id") &&
      this.state.nodeData.type === TAXONOMY &&
      this.deleteData("taxonomy/" + this.state.nodeData.id + "/children");
  };
  removeChildren = (nodeData) => {
    nodeData.hasOwnProperty("id") &&
      nodeData.type === TAXONOMY &&
      this.deleteData("taxonomy/" + nodeData.id + "/children");
  };
  handleSelectedAdd = (e, type) => {
    if (this.state.nodeDataTarget !== null) {
      const icon =
        type === TAXONOMY ? taxonomySVG : type === TEAM ? teamSVG : topicSVG;
      let d = { id: "-1", type: type, name: type, icon: icon };
      this.setState({ selectedItemMenu: false }, () =>
        this.dragDropAction(d, this.state.nodeDataTarget)
      );
    }
  };
  handleAdd = (d, dragTarget, anchorEl) => {
    this.setState({ anchorEl: anchorEl }, () =>
      this.dragDropAction(d, dragTarget)
    );
  };
  handleCopy = (copiedData, childrenOnly) => {
    this.setState({
      copiedData: copiedData,
      childrenOnly: childrenOnly,
      selectedItemMenu: false,
    });
  };
  pasteCopiedData = () => {
    if (this.state.nodeData !== null && this.state.copiedData !== null) {
      if (this.state.nodeData.type === TAXONOMY) {
        let cloneId =
          this.state.copiedData.type === TAXONOMY
            ? this.state.copiedData.id
            : this.state.copiedData.type === TEAM
              ? this.state.copiedData.object.teamId
              : this.state.copiedData.type === TOPIC
                ? this.state.copiedData.object.topicId
                : "";
        let parentId =
          this.state.copiedData.object !== null
            ? this.state.copiedData.object.taxonomyId
            : this.state.copiedData.parentList[
                this.state.copiedData.parentList.length - 1
              ];
        const url = "taxonomy/clone/";
        const obj = {
          targetId: this.state.nodeData.id,
          cloneId: cloneId,
          cloneType: this.state.copiedData.type,
          childrenOnly: this.state.childrenOnly,
          parentTaxonomyId: parentId,
        };
        this.postData(url, obj);
      }
    }
    this.setState({ selectedItemMenu: false });
  };
  unsetLevel() {
    this.setState({ setLevel: false });
  }
  updateTreeState(currentState) {
    this.setState({ treeState: currentState });
  }
  unsetExpanded() {
    this.setState({ setExpanded: false });
  }
  topicSelected = (topic) => {
    this.setState({
      selectedItem: topic,
      sourceNeedsUpdate: true,
      numKnowledgeSources: 0,
    });
  };
  teamSelected = (team) => {
    this.setState({ selectedItem: team });
  };
  organizationSelected(organization) {
    this.setState({
      organization: organization,
      selectedItem: organization,
      nodeData: null,
    });
  }
  getTopicSecondaryInfo = (item) => {
    const result = "Attached: " + item.attached;
    return result;
  };
  isTopicItemEnabled = (item) => {
    return (item.attached && item.attached) > 0 ? true : false;
  };
  isTeamItemEnabled = (item) => {
    return (item.attached && item.attached) > 0 ? true : false;
  };
  getTeamSecondaryInfo = (item) => {
    const result = "Members : " + item.members + " Attached: " + item.attached;
    return result;
  };
  getUserPrimaryInfo = (item) => {
    return (
      <>{item.firstName + " " + item.surname + " (" + item.userLogin + ")"}</>
    );
  };
  getUserSecondaryInfo = (item) => {
    const { classes, theme } = this.props;
    const userName =
      item.firstName + " " + item.surname + " (" + item.userLogin + ")";
    return (
      <div style={{ display: "flex" }}>
        {item.userPermits &&
          Object.entries(item.userPermits.roles).map(([key, value]) => {
            return (
              <>
                {value === true &&
                  this.state.hasOwnProperty(key) && (
                    <Tooltip
                      title={
                        <Typography>
                          {
                            this.getUserRoleTooltip(
                              key,
                              userName,
                              item.userPermits.roles.systemManager
                          )}
                        </Typography>
                      }
                      enterDelay={300}
                    >
                      <SvgIcon classes={{ root: classes.userRoleIcon }}>
                        <path
                          d={this.state[key]}
                          fill={
                            this.state.nodeData.object[
                              key.toLowerCase() === "beexpert" ? "expert" : key
                            ] === true ||
                            item.userPermits.roles.systemManager === true
                              ? this.state.teamColourTheme
                              : this.state.disabledColourTheme
                          }
                        />
                      </SvgIcon>
                    </Tooltip>
                  )}
              </>
            );
          })}
      </div>
    );
  };
  getUserRoleTooltip = (key, userName, isSystemManager) => {
    const { classes, theme } = this.props;
    const keyName = key.toLowerCase() === "beexpert" ? "expert" : key;
    const teamName = this.state.nodeData.name ? this.state.nodeData.name : "";
    const roleButNotSelected = (
      <>
        <div style={{ display: "flex" }}>
          <div style={{ margin: theme.spacing(1), verticalAlign: "middle" }}>
            <HelpOutlineIcon />
          </div>
          <div style={{ margin: theme.spacing(1) }}>
            <Typography>
              {userName} has role {key} but no node on the Tree is currently
              selected to check against
            </Typography>
          </div>
        </div>
      </>
    );
    return (
      <>
        {this.state.nodeData.object ? (
          this.state.nodeData.object.hasOwnProperty(keyName) ? (
            this.state.nodeData.object[keyName] === true ||
            isSystemManager === true ? (
              <div style={{ display: "flex" }}>
                <div
                  style={{ margin: theme.spacing(1), verticalAlign: "middle" }}
                >
                  <CheckCircleIcon className={classes.green} />
                </div>
                <div style={{ margin: theme.spacing(1) }}>
                  {isSystemManager === true ? (
                    <Typography>
                      {userName} has the System Manager role and can perform all
                      tasks on all nodes
                    </Typography>
                  ) : (
                    <Typography>
                      {userName} has the role {key} and the Team {teamName} has
                      the Role on the selected node{" "}
                      {this.state.nodeData.taxonomyName}
                    </Typography>
                  )}
                </div>
              </div>
            ) : (
              <div style={{ display: "flex" }}>
                <div
                  style={{ margin: theme.spacing(1), verticalAlign: "middle" }}
                >
                  <CancelIcon />
                </div>
                <div style={{ margin: theme.spacing(1) }}>
                  <Typography>
                    {userName} has the role {key} but the Team {teamName} has
                    not been granted the role for the selected node{" "}
                    {this.state.nodeData.taxonomyName}
                  </Typography>
                </div>
              </div>
            )
          ) : (
            <>{roleButNotSelected}</>
          )
        ) : (
          <>{roleButNotSelected}</>
        )}
      </>
    );
  };

  getRoleTooltip = (key) => {
    const { classes, theme } = this.props;
    const keyName = key.toLowerCase() === "beexpert" ? "expert" : key;
    const isChecked = this.state.nodeData.object[key];
    return (
      <>
        {isChecked === true ? (
          <Typography>
            Any user with the role <b><Trans i18nKey={key} /></b> will be able to
            perform this role on Knowledge anywhere below this point in the tree
          </Typography>
        ) : (
          <Typography>
            Check this to allow users with this role to perform this function on
            knowledge anywhere below this point
          </Typography>
        )}
      </>
    );
  };

  isUserItemEnabled = (item) => {
    return item.inactive === 0;
  };

  userSelected = () => {};
  editUser = () => {};
  editSource = () => {
    this.props.history.push("/full/knowledgesource", {
      edit: true,
      ksId: this.state.selectedSource,
    })
  }
  openAddUserDialog = () => {
    this.setState({ addUserDialogOpen: true });
  };

  closeAddUserDialog = () => {
    this.setState({ addUserDialogOpen: false });
  };

  addUserDialogSubmit = (user) => {
    taxServiceClient
      .post("/user/", {
        language: user.preferedLanguage,
        phone: user.phoneNumber,
        ...user,
      })
      .then((res) => {
        this.props.enqueueSnackbar(this.props.t("user_admin_user_added"), {
          variant: "success",
        });
        this.closeAddUserDialog();
        this.setState({
          users: [...this.state.users, res.data],
        });
      })
      .catch((err) => {
        this.props.enqueueSnackbar(
          this.props.t("workflow_error", { error: err.response.data.message }),
          {
            variant: "error",
          }
        );
      });
  };
  getSourceSecondaryInfo = (item) => {
    const classes = this.props;
    return (
      <>
        <Typography
          display="block"
          noWrap={true}
          style={{ width: drawerWidth - 150 }}
        >
          {item.url}
        </Typography>
      </>
    );
  };
  isSourceItemEnabled = (item) => {
    return true;
  };
  sourceSelected = (item) => {
    this.setState({selectedSource: item.sourceId})
  };
  openAddSourceDialog = () => {
    this.setState({
      addSourceDialogOpen: true,
    });
  };
  closeAddSourceDialog = () => {
    this.setState({ addSourceDialogOpen: false });
  };
  openOrganizationDialog = () => {
    this.setState({ createOrganizationDialogOpen: true });
  };
  openAddTopicDialog = (e) => {
    this.setState({
      drawerDialogOpen: true,
      addItem: { type: "topic" },
      drawerDialogAnchor: e.target,
    });
  };
  openAddTeamDialog = (e) => {
    this.setState({
      addItem: { type: "team" },
      drawerDialogOpen: true,
      drawerDialogAnchor: e.target,
    });
  };
  editOrganization = (e) => {
    e.preventDefault();
    const nodeData = {
      id: this.state.selectedItem.organizationId,
      type: ORGANIZATION,
      object: { organizationId: this.state.selectedItem.organizationId },
      name: this.state.selectedItem.organizationName,
    };
    this.setState({
      expandedPanel: "selectionDetails",
      nodeData: nodeData,
    });
  };
  editTopic = (e) => {
    e.preventDefault();
    // alert("Team");
    const nodeData = {
      id: this.state.selectedItem.topicId,
      type: TOPIC,
      object: { topicId: this.state.selectedItem.topicId },
      name: this.state.selectedItem.topicName,
    };
    this.setState({
      expandedPanel: "selectionDetails",
      nodeData: nodeData,
      sourceNeedsUpdate: true,
    });
  };
  editTeam = (e) => {
    e.preventDefault();
    // alert("Team");
    const nodeData = {
      id: this.state.selectedItem.teamId,
      type: TEAM,
      object: { teamId: this.state.selectedItem.teamId },
      name: this.state.selectedItem.teamName,
    };
    this.setState({
      expandedPanel: "selectionDetails",
      nodeData: nodeData,
      userNeedsUpdate: true,
    });
  };
  closeOrgDialog = () => {
    this.setState({ createOrganizationDialogOpen: false });
    this.getOrganizations();
  };
  dragStart = (ev) => {
    const { theme, classes } = this.props;
    //called by native dnd
    ev.stopPropagation();
    ev.dataTransfer.setData("text/plain", "");

    let data = ev.target.getAttribute("d");
    let d = JSON.parse(data);
    this.setState({
      isDragging: true,
      draggingNode: d,
      dragOrigin: null,
    });
    const dragCtr = this.dragRef.current;
    ev.dataTransfer.setDragImage(dragCtr, ev.offsetX, ev.offsetY);
    ev.dataTransfer.effectAllowed = "move";
    ev.dataTransfer.dropEffect = "move";
  };
  dragEnd = (ev) => {
    //called by native dnd
    //  d3.selectAll("circle.target").style("fill-opacity", 0);
    let data = ev.target.getAttribute("d");
    let d = JSON.parse(data);
    if (d.type === ORGANIZATION) {
      this.setState({
        organization: this.state.orgdata.filter(
          (item) => item.organizationId === d.id
        )[0],
        isDragging: false,
        draggingNode: null,
        dragOrigin: null,
      });
    } else {
      if (this.state.dragTarget !== null) {
        this.dragDropAction(d, this.state.dragTarget);
      } else {
        this.setState({
          isDragging: false,
          draggingNode: null,
          dragOrigin: null,
        });
      }
    }
  };
  dragOver = (ev) => {
    //called by native dnd needed to set cursor
    ev.dataTransfer.dropEffect = "move";
    ev.dataTransfer.effectAllowed = "move";
    ev.preventDefault();
  };
  setDragTarget = (target) => {
    this.setState({
      dragTarget: target,
    });
  };
  setAnchorEl = (target) => {
    this.setState({
      anchorEl: target,
    });
  };

  getRoleRow = (key) => {
    const { classes, theme } = this.props;
    return (
      <>
        {typeof this.state.nodeData.object[key] === "boolean" && (
          <TableRow>
            <TableCell classes={{ sizeSmall: classes.tableCellSmall }}>
              <Tooltip title={this.getRoleTooltip(key)} enterDelay={300}>
                <div style={{ display: "flex" }}>
                  <SvgIcon classes={{ root: classes.userRoleIcon }}>
                    <path
                      d={
                        this.state[
                          key.toLowerCase() === "expert" ? "beExpert" : key
                        ]
                      }
                      fill={this.state.teamColourTheme}
                    />
                  </SvgIcon>
                  <FormControlLabel
                    aria-label={key}
                    data-value={this.state.nodeData.object[key]}
                    control={
                      <Checkbox
                        onClick={(event) =>
                          this.handleNodeDataChange(key, event.target.checked)
                        }
                        checked={this.state.nodeData.object[key]}
                      />
                    }
                    label={key}
                  />
                </div>
              </Tooltip>
            </TableCell>
          </TableRow>
        )}
      </>
    );
  };
  handleSelectedItemMenu = (e) => {
    let prev = this.state.selectedItemMenu;
    this.setState({ anchorEl: e.currentTarget, selectedItemMenu: !prev });
  };
  handleSelectedItemMenuClose = () => {
    this.setState({ selectedItemMenu: false });
  };
  getSelectedItemMenu = () => {
    return (
      <div>
        {this.state.nodeData.type !== ORGANIZATION && (
          <>
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={this.handleSelectedItemMenu}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={this.state.anchorEl}
              open={this.state.selectedItemMenu}
              onClose={this.handleSelectedItemMenuClose}
            >
              {(this.state.nodeData.type === TEAM ||
                this.state.nodeData.type === TOPIC) && (
                <MenuItem
                  key={"removeAll"}
                  onClick={this.removeSelectedFromTree}
                >
                  Remove ALL from Tree
                </MenuItem>
              )}
              {this.state.nodeData.type === TAXONOMY && (
                <>
                  {this.state.treeStart === null ||
                  this.state.nodeData.id !== this.state.treeStart.id ? (
                    <MenuItem key={"startHere"} onClick={this.setTreeStart}>
                      Start Tree from Here
                    </MenuItem>
                  ) : (
                    <MenuItem key={"showAll"} onClick={this.resetTreeStart}>
                      Show All
                    </MenuItem>
                  )}
                  <MenuItem
                    disabled={this.state.nodeData.children.length === 0}
                    key={"removeChildren"}
                    onClick={this.removeSelectedChildren}
                  >
                    Remove Children
                  </MenuItem>
                  <MenuItem
                    onClick={(e) => this.handleSelectedAdd(e, TAXONOMY)}
                  >
                    Add Taxonomy Node
                  </MenuItem>
                  <MenuItem onClick={(e) => this.handleSelectedAdd(e, TEAM)}>
                    Add Team
                  </MenuItem>
                  <MenuItem onClick={(e) => this.handleSelectedAdd(e, TOPIC)}>
                    Add Topic
                  </MenuItem>
                  <MenuItem
                    disabled={this.state.copiedData === null}
                    key={"paste"}
                    onClick={this.pasteCopiedData}
                  >
                    Paste
                  </MenuItem>
                </>
              )}
              {this.state.nodeData.type !== ORGANIZATION && (
                <MenuItem
                  key={"copy"}
                  onClick={() => this.handleCopy(this.state.nodeData, false)}
                >
                  Copy
                </MenuItem>
              )}
              {this.state.nodeData.type === TAXONOMY && (
                <MenuItem
                  key={"copyChildren"}
                  disabled={this.state.nodeData.children.length === 0}
                  onClick={() => this.handleCopy(this.state.nodeData, true)}
                >
                  {"Copy Children Only"}
                </MenuItem>
              )}
            </Menu>
          </>
        )}
      </div>
    );
  };
  getUnlinkTooltip = () => {
    const { classes, theme } = this.props;
    return (
      <div>
        <Typography>Remove</Typography>
        <div
          style={{
            display: "flex",
            whiteSpace: "nowrap",
          }}
        >
          <SvgIcon classes={{ root: classes.unlinkIcon }}>
            <path
              fill={
                this.state.nodeData.type === TEAM
                  ? this.state.teamColourTheme
                  : this.state.nodeData.type === TOPIC
                    ? this.state.topicColourTheme
                    : this.state.nodeData.type === TAXONOMY
                      ? this.state.taxonomyColourTheme
                      : `${this.props.theme.palette.text.primary}`
              }
              d={
                this.state.nodeData.type === TEAM
                  ? teamSVG
                  : this.state.nodeData.type === TOPIC
                    ? topicSVG
                    : this.state.nodeData.type === TAXONOMY
                      ? taxonomySVG
                      : this.state.nodeData.type === ORGANIZATION
                        ? organizationSVG
                        : defaultSVG
              }
            />
          </SvgIcon>
          <Typography>{this.state.nodeData.name}</Typography>
        </div>
        <Typography>from</Typography>
        <div
          style={{
            display: "flex",
            whiteSpace: "nowrap",
          }}
        >
          <SvgIcon classes={{ root: classes.unlinkIcon }}>
            <path fill={this.state.taxonomyColourTheme} d={taxonomySVG} />
          </SvgIcon>
          <Typography>{this.state.nodeData.taxonomyName}</Typography>
        </div>
      </div>
    );
  };
  render() {
    const { classes, theme, t } = this.props;
    return (
      <>
        <div className={classes.dragItemContainer} ref={this.dragRef}>
          {this.state.draggingNode !== null && (
            <div className={classes.dragItem}>
              <SvgIcon>
                <path
                  d={this.state.draggingNode.icon}
                  fill={
                    this.state.draggingNode.type === TAXONOMY
                      ? this.state.taxonomyColourTheme
                      : this.state.draggingNode.type === TEAM
                        ? this.state.teamColourTheme
                        : this.state.topicColourTheme
                  }
                />
              </SvgIcon>
              <div className={classes.dragItemName}>
                {this.state.draggingNode.hasOwnProperty("name")
                  ? this.state.draggingNode.name
                  : ""}
              </div>
            </div>
          )}
        </div>
        <div className={classes.pageContainer}>
          {this.state.createOrganizationDialogOpen && (
            <CreateOrganizationDialog
              fromMenu={false}
              open={this.state.createOrganizationDialogOpen}
              handleClose={this.closeOrgDialog}
            />
          )}

          <Popper
            disablePortal
            open={this.state.dropDialogOpen}
            anchorEl={this.state.anchorEl}
            placement={"right-end"}
            className={classes.popper}
            modifiers={{
              flip: {
                enabled: true,
              },
              arrow: {
                enabled: true,
                element: this.state.arrowRef,
              },
              preventOverflow: {
                enabled: true,
                escapeWithReference: false,
              },
            }}
          >
            <span className={classes.arrow} ref={this.handleArrowRef} />
            <Paper className={classes.paper} elevation={10}>
              <IconButton
                aria-label="Close"
                className={classes.closeButton}
                onClick={this.handleDropDialogClose}
              >
                <CloseIcon />
              </IconButton>
              <DialogTitle className={classes.dialogTitle}>
                <Trans i18nKey="global_add" />{" "}
                {this.state.dragItem ? (
                  this.state.dragItem.type === TAXONOMY ? (
                    <Trans i18nKey="global_new_taxonomy_node" />
                  ) : this.state.dragItem.type === TOPIC ? (
                    <Trans i18nKey="global_new_topic" />
                  ) : (
                    <Trans i18nKey="global_new_team" />
                  )
                ) : (
                  <Trans i18nKey="global_item" />
                )}
              </DialogTitle>
              <DialogContent>
                {this.state.dragItem &&
                  (this.state.dragItem.data ? (
                    <></>
                  ) : this.state.dragItem.type === TAXONOMY ? (
                    <TextField
                      id="add-taxonomy-node-input"
                      onChange={this.onTextChange}
                      fullWidth
                    />
                  ) : this.state.dragItem.type === TOPIC ? (
                    <TopicAutosuggest
                      id="add-topic-node-input"
                      organizationId={this.state.organization.organizationId}
                      onFilterChange={this.onFilterChange}
                      onItemSelected={this.onItemSelected}
                    />
                  ) : (
                    this.state.dragItem.type === TEAM && (
                      <TeamAutosuggest
                        id="add-team-node-input"
                        organizationId={this.state.organization.organizationId}
                        onFilterChange={this.onFilterChange}
                        onItemSelected={this.onItemSelected}
                      />
                    )
                  ))}
              </DialogContent>
              <DialogActions>
                <Button
                  id="add-taxonomy-node-submit"
                  onClick={this.handleDropDialogSubmit}
                  color="primary"
                  autoFocus
                  disabled={
                    this.state.filterValue === null &&
                    this.state.selectedItem === null
                      ? true
                      : false
                  }
                >
                  {this.state.selectedItem !== null ? (
                    <Trans i18nKey="global_submit" />
                  ) : (
                    <Trans i18nKey="global_add" />
                  )}
                </Button>
              </DialogActions>
            </Paper>
          </Popper>

          <div className={classes.sidebarContainer}>
            <FormControl className={classes.formControl}>
              <Button
                id="toggle-hide-teams"
                onClick={(event) =>
                  this.setState((prev) => ({ showTeam: !prev.showTeam }))
                }
                color="primary"
              >
                <svg height="24px" width="24px">
                  <path
                    fill={
                      this.state.showTeam ? this.state.teamColourTheme : "grey"
                    }
                    d={teamSVG}
                  />
                </svg>
              </Button>
              <Button
                id="toggle-hide-topics"
                onClick={(event) =>
                  this.setState((prev) => ({ showTopic: !prev.showTopic }))
                }
                color="primary"
              >
                <svg height="24px" width="24px">
                  <path
                    fill={
                      this.state.showTopic
                        ? this.state.topicColourTheme
                        : "grey"
                    }
                    d={topicSVG}
                  />
                </svg>
              </Button>
              <Button
                onClick={(event) =>
                  this.setState((prev) => ({ landscape: !prev.landscape }))
                }
                color="primary"
              >
                <svg height="24px" width="24px">
                  <path d={this.state.landscape ? portraitSVG : landscapeSVG} />
                </svg>
              </Button>
              <Button
                id="toggle-collapse-tree"
                onClick={(event) => this.setState(() => ({ setLevel: true }))}
                color="primary"
              >
                <svg height="24px" width="24px">
                  <path d={collapseLevel1SVG} />
                </svg>
              </Button>
              <Button
                id="toggle-expand-tree"
                onClick={(event) =>
                  this.setState(() => ({ setExpanded: true }))
                }
                color="primary"
              >
                <svg height="24px" width="24px">
                  <path d={expandAllSVG} />
                </svg>
              </Button>
            </FormControl>
          </div>

          <div className={classes.treeContainer}>
            <Dialog open={this.state.confirmDialogOpen}>
              <DialogTitle>
                <Trans i18nKey="global_are_you_sure" />
              </DialogTitle>
              <DialogContent>
                <Trans i18nKey="taxonomy_confirm_delete_body" />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    this.setState({ confirmDialogOpen: false, deleteUrl: "" });
                  }}
                  color="primary"
                >
                  <Trans i18nKey="global_no" />
                </Button>
                <Button
                  onClick={() => this.confirmDeleteData()}
                  color="primary"
                >
                  <Trans i18nKey="global_yes" />
                </Button>
              </DialogActions>
            </Dialog>
            <AddUserDialog
              open={this.state.addUserDialogOpen}
              onClose={this.closeAddUserDialog}
              onSubmit={this.addUserDialogSubmit}
            />
            {this.state.addSourceDialogOpen && (
              <CreateKnowledgeSource
                asDialog={true}
                open={this.state.addSourceDialogOpen}
                handleClose={this.closeAddSourceDialog}
                topic={
                  this.state.nodeData.type === TOPIC
                    ? this.state.nodeData.id
                    : ""
                }
                topicName={
                  this.state.nodeData.type === TOPIC
                    ? this.state.nodeData.name
                    : ""
                }
              />
            )}

            <AutoSizer>
              {({ height, width }) => (
                <TreeComponent
                  data={this.state.data}
                  updateTreeState={this.updateTreeState}
                  treeState={this.state.treeState}
                  dragDropAction={this.dragDropAction}
                  height={height}
                  width={width}
                  margin={this.state.margin}
                  showTeam={this.state.showTeam}
                  showTopic={this.state.showTopic}
                  nodeClick={this.nodeClicked}
                  chartClick={this.closeSidebar}
                  dragDropEnabled={true}
                  landscape={this.state.landscape}
                  selectedNodeData={this.state.nodeData}
                  treeStart={this.state.treeStart}
                  setLevel={this.state.setLevel}
                  onSetLevel={this.unsetLevel}
                  setExpanded={this.state.setExpanded}
                  onSetExpanded={this.unsetExpanded}
                  dragStart={this.dragStart}
                  dragEnd={this.dragEnd}
                  dragOver={this.dragOver}
                  isDragging={this.state.isDragging}
                  draggingNode={this.state.draggingNode}
                  dragOrigin={this.state.dragOrigin}
                  dragTarget={this.state.dragTarget}
                  setDragTarget={this.setDragTarget}
                  setAnchorEl={this.setAnchorEl}
                  changeTreeStart={this.changeTreeStart}
                  removeFromTree={this.removeFromTree}
                  removeChildren={this.removeChildren}
                  copiedData={this.state.copiedData}
                  handleCopy={this.handleCopy}
                  handlePaste={(targetData) =>
                    this.setState({ nodeData: targetData }, () =>
                      this.pasteCopiedData()
                    )
                  }
                  unlinkFromTree={(targetData) =>
                    this.unlinkFromTreeForContextMenu(targetData)
                  }
                  handleAdd={this.handleAdd}
                  organization={this.state.organization}
                />
              )}
            </AutoSizer>
          </div>
          <div className={classes.sidebarContainer}>
            <Drawer
              variant="permanent"
              className={classNames(classes.drawer, {
                [classes.drawerOpen]: this.state.sidebarOpen,
                [classes.drawerClose]: !this.state.sidebarOpen,
              })}
              classes={{
                paper: classNames({
                  [classes.drawerOpen]: this.state.sidebarOpen,
                  [classes.drawerClose]: !this.state.sidebarOpen,
                }),
                paperAnchorLeft: null,
              }}
              open={this.state.sidebarOpen}
            >
              <Popper
                disablePortal
                open={this.state.drawerDialogOpen}
                anchorEl={this.state.drawerDialogAnchor}
                placement={"right-end"}
                className={classes.popper}
                modifiers={{
                  flip: {
                    enabled: true,
                  },
                  arrow: {
                    enabled: true,
                    element: this.state.arrowRef,
                  },
                  preventOverflow: {
                    enabled: true,
                    escapeWithReference: false,
                  },
                }}
              >
                <span className={classes.arrow} ref={this.handleArrowRef} />
                <Paper className={classes.paper} elevation={10}>
                  <IconButton
                    aria-label="Close"
                    className={classes.closeButton}
                    onClick={this.handleDrawerDialogClose}
                  >
                    <CloseIcon />
                  </IconButton>
                  <DialogTitle className={classes.dialogTitle}>
                    <Trans i18nKey="global_add" />{" "}
                    {this.state.addItem !== null ? (
                      this.state.addItem.type === TOPIC ? (
                        <Trans i18nKey="global_new_topic" />
                      ) : (
                        <Trans i18nKey="global_new_team" />
                      )
                    ) : (
                      <Trans i18nKey="global_item" />
                    )}
                  </DialogTitle>
                  <DialogContent>
                    {this.state.addItem !== null ? (
                      this.state.addItem.type === TOPIC ? (
                        <TopicAutosuggest
                          organizationId={
                            this.state.organization.organizationId
                          }
                          onFilterChange={this.onFilterChange}
                          onItemSelected={this.onItemSelected}
                        />
                      ) : (
                        this.state.addItem.type === TEAM && (
                          <TeamAutosuggest
                            organizationId={
                              this.state.organization.organizationId
                            }
                            onFilterChange={this.onFilterChange}
                            onItemSelected={this.onItemSelected}
                          />
                        )
                      )
                    ) : (
                      <></>
                    )}
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={this.handleDrawerDialogSubmit}
                      color="primary"
                      autoFocus
                      disabled={
                        this.state.filterValue === null &&
                        this.state.selectedItem === null
                      }
                    >
                      <Trans i18nKey="global_add" />
                    </Button>
                  </DialogActions>
                </Paper>
              </Popper>

              <IconButton
                aria-label="Sidebar toggle"
                onClick={this.toggleSidebar}
                className={classes.sidebarIcon}
              >
                {this.state.sidebarOpen ? (
                  <ChevronRightIcon />
                ) : (
                  <ChevronLeftIcon />
                )}
              </IconButton>
              {this.state.sidebarOpen && (
                <>
                  {this.state.nodeData !== null && (
                    <Accordion
                      key="selectionDetails"
                      className={classes.expansionPanel}
                      expanded={this.state.expandedPanel === "selectionDetails"}
                      onChange={this.handlePanelChange("selectionDetails")}
                    >
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography className={classes.heading}>
                          <Trans i18nKey="selected_item_details" />
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div style={{ width: "100%" }}>
                          {this.state.nodeData !== null && (
                            <>
                              <div>
                                {this.state.nodeData.type !== ORGANIZATION && (
                                  <FormControl>
                                    <TextField
                                      // error
                                      InputProps={{
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            <svg height="24px" width="24px">
                                              <path
                                                fill={
                                                  this.state.nodeData.type ===
                                                  TEAM
                                                    ? this.state.teamColourTheme
                                                    : this.state.nodeData
                                                        .type === TOPIC
                                                      ? this.state
                                                          .topicColourTheme
                                                      : this.state.nodeData
                                                          .type === TAXONOMY
                                                        ? this.state
                                                            .taxonomyColourTheme
                                                        : `${
                                                            this.props.theme
                                                              .palette.text
                                                              .primary
                                                          }`
                                                }
                                                d={
                                                  this.state.nodeData.type ===
                                                  TEAM
                                                    ? teamSVG
                                                    : this.state.nodeData
                                                        .type === TOPIC
                                                      ? topicSVG
                                                      : this.state.nodeData
                                                          .type === TAXONOMY
                                                        ? taxonomySVG
                                                        : this.state.nodeData
                                                            .type ===
                                                          ORGANIZATION
                                                          ? organizationSVG
                                                          : defaultSVG
                                                }
                                              />
                                            </svg>
                                          </InputAdornment>
                                        ),
                                      }}
                                      id="filled-error-helper-text"
                                      label=""
                                      value={
                                        this.state.nodeData.name === null
                                          ? ""
                                          : this.state.nodeData.name
                                      }
                                      // helperText="Incorrect entry."
                                      className={classes.textField}
                                      margin="normal"
                                      variant="filled"
                                      onChange={(event) =>
                                        this.handleDataChange(
                                          "name",
                                          event.target.value
                                        )
                                      }
                                    />
                                  </FormControl>
                                )}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  verticalAlign: "middle",
                                }}
                              >
                                {this.getSelectedItemMenu()}
                                {this.state.nodeData.taxonomyName && (
                                  <div className={classes.unlinkShortcut}>
                                    <FormControl>
                                      <Tooltip
                                        classes={{
                                          arrow: classes.toolTipArrow,
                                        }}
                                        title={this.getUnlinkTooltip()}
                                        enterDelay={300}
                                        arrow={true}
                                      >
                                        <Button
                                          onClick={this.unlinkFromTree}
                                          startIcon={
                                            <svg height="24px" width="24px">
                                              <path
                                                fill={
                                                  this.state.taxonomyColourTheme
                                                }
                                                d={taxonomySVG}
                                              />
                                            </svg>
                                          }
                                          endIcon={
                                            <svg height="24px" width="24px">
                                              <path
                                                fill={
                                                  this.state.taxonomyColourTheme
                                                }
                                                d={unlinkSVG}
                                              />
                                            </svg>
                                          }
                                          fullWidth={true}
                                        >
                                          {this.state.nodeData.taxonomyName}
                                        </Button>
                                      </Tooltip>
                                    </FormControl>
                                  </div>
                                )}
                              </div>
                              {this.state.nodeData.type === TEAM &&
                                this.state.nodeData.taxonomyName && (
                                  <div className={classes.roleCtr}>
                                    <Typography>
                                      Roles for {this.state.nodeData.name} on{" "}
                                      {this.state.nodeData.taxonomyName}
                                    </Typography>
                                  </div>
                                )}
                              <div className={classes.roleCtr}>
                                <Table size={"small"}>
                                  {this.state.nodeData.object &&
                                    Object.keys(this.state.nodeData.object).map(
                                      function(key, index) {
                                        if (index % 2 === 0) {
                                          return <>{this.getRoleRow(key)}</>;
                                        }
                                      }.bind(this)
                                    )}
                                </Table>
                                <Table size={"small"}>
                                  {this.state.nodeData.object &&
                                    Object.keys(this.state.nodeData.object).map(
                                      function(key, index) {
                                        if (index % 2 > 0) {
                                          return <>{this.getRoleRow(key)}</>;
                                        }
                                      }.bind(this)
                                    )}
                                </Table>
                              </div>
                              <div className={classes.classificationCtr}>
                                {this.state.nodeData.object &&
                                  this.state.nodeData.object.hasOwnProperty(
                                    "classification"
                                  ) && (
                                    <TextField
                                      id="select-clasification"
                                      select
                                      label="Select"
                                      value={
                                        this.state.nodeData.object[
                                          "classification"
                                        ]
                                      }
                                      onChange={(event) =>
                                        this.handleNodeDataChange(
                                          "classification",
                                          event.target.value
                                        )
                                      }
                                      helperText="Classification Level for this Team"
                                    >
                                      {this.state.classifications.map(
                                        (option) => (
                                          <MenuItem
                                            key={option.value}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </MenuItem>
                                        )
                                      )}
                                    </TextField>
                                  )}
                              </div>
                              {this.state.nodeData.type === TEAM && (
                                <FormControl>
                                  <Accordion
                                    key="members"
                                    className={classes.expansionPanel}
                                    expanded={
                                      this.state.showMembers
                                        ? this.state.showMembers
                                        : false
                                    }
                                    onChange={() => {
                                      this.setState((prev) => ({
                                        showMembers: !prev.showMembers,
                                      }));
                                    }}
                                  >
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                    >
                                      <div className={classes.panelSummaryIcon}>
                                        <svg height="24px" width="24px">
                                          <path
                                            fill={this.state.teamColourTheme}
                                            d={userSVG}
                                          />
                                        </svg>
                                      </div>
                                      <Typography className={classes.heading}>
                                        Team Members ({this.state.numTeamUsers})
                                      </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      <div>
                                        {this.props.licence &&
                                          this.props.licence.usedUsers >=
                                            this.props.licence.namedUsers && (
                                            <Alert
                                              severity="warning"
                                              style={{
                                                margin: 10,
                                                marginBottom: 0,
                                              }}
                                            >
                                              <Trans i18nKey="licence_user_limit_reached">
                                                licence_user_limit_reached
                                              </Trans>
                                            </Alert>
                                          )}
                                        <FilterableList
                                          dataurl={
                                            "/team/" +
                                            this.state.nodeData.object.teamId +
                                            "/users/"
                                          }
                                          // filterElement={"FilterUsers"}
                                          name="userLogin"
                                          getPrimaryInfo={
                                            this.getUserPrimaryInfo
                                          }
                                          getSecondaryInfo={
                                            this.getUserSecondaryInfo
                                          }
                                          isItemEnabled={this.isUserItemEnabled}
                                          iconColour={
                                            this.state.teamColourTheme
                                          }
                                          iconColourDisabled={
                                            this.state.disabledColourTheme
                                          }
                                          iconSVG={userSVG}
                                          onItemSelected={this.userSelected}
                                          organization={this.state.organization}
                                          dragStart={this.dragStart}
                                          dragEnd={this.dragEnd}
                                          addItem={this.openAddUserDialog}
                                          addDisabled={
                                            this.props.licence &&
                                            this.props.licence.usedUsers >=
                                              this.props.licence.namedUsers
                                          }
                                          editItem={this.editUser}
                                          needsUpdate={
                                            this.state.userNeedsUpdate
                                          }
                                          onUpdate={(total) => {
                                            this.setState({
                                              userNeedsUpdate: false,
                                              numTeamUsers: total,
                                            });
                                          }}
                                        />
                                      </div>
                                    </AccordionDetails>
                                  </Accordion>
                                </FormControl>
                              )}
                              {this.state.nodeData.type === TOPIC && (
                                <FormControl>
                                  <Accordion
                                    key="sources"
                                    className={classes.expansionPanel}
                                    expanded={
                                      this.state.showSources
                                        ? this.state.showSources
                                        : false
                                    }
                                    onChange={() => {
                                      this.setState((prev) => ({
                                        showSources: !prev.showSources,
                                      }));
                                    }}
                                  >
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                    >
                                      <div className={classes.panelSummaryIcon}>
                                        <svg height="24px" width="24px">
                                          <path
                                            fill={this.state.topicColourTheme}
                                            d={userSVG}
                                          />
                                        </svg>
                                      </div>
                                      <Typography className={classes.heading}>
                                        Knowledge Sources ({
                                          this.state.numKnowledgeSources
                                        })
                                      </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      <FilterableList
                                        dataurl={
                                          "/knowledgesource/topic/" +
                                          this.state.nodeData.object.topicId +
                                          "/"
                                        }
                                        // filterElement={"FilterKnowledgeSources"}
                                        name="description"
                                        getSecondaryInfo={
                                          this.getSourceSecondaryInfo
                                        }
                                        isItemEnabled={this.isSourceItemEnabled}
                                        iconColour={this.state.topicColourTheme}
                                        iconColourDisabled={
                                          this.state.disabledColourTheme
                                        }
                                        iconSVG={sourceSVG}
                                        onItemSelected={this.sourceSelected}
                                        organization={this.state.organization}
                                        dragStart={this.dragStart}
                                        dragEnd={this.dragEnd}
                                        addItem={this.openAddSourceDialog}
                                        editItem={this.editSource}
                                        needsUpdate={
                                          this.state.sourceNeedsUpdate
                                        }
                                        onUpdate={(total) => {
                                          this.setState({
                                            sourceNeedsUpdate: false,
                                            numKnowledgeSources: total,
                                          });
                                        }}
                                      />
                                    </AccordionDetails>
                                  </Accordion>
                                </FormControl>
                              )}
                              {this.state.nodeData.type === ORGANIZATION && (
                                <OrganizationEditor
                                  organizationId={this.state.nodeData.id}
                                  updateOrganization={() =>
                                    this.setState(
                                      { organizationNeedsUpdate: true },
                                      () => {
                                        this.getOrganizations();
                                      }
                                    )
                                  }
                                />
                              )}
                            </>
                          )}
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  )}
                  <Accordion
                    key="organization"
                    className={classes.expansionPanel}
                    expanded={
                      this.state.expandedPanel === "organizationSelection"
                    }
                    onChange={this.handlePanelChange("organizationSelection")}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <div className={classes.panelSummaryIcon}>
                        <svg height="24px" width="24px">
                          <path
                            fill={this.state.organizationColourTheme}
                            d={organizationSVG}
                          />
                        </svg>
                      </div>
                      <Typography className={classes.heading}>
                        {this.state.orgdata.length > 1 ? (
                          <Trans i18nKey="global_organization_plural" />
                        ) : (
                          <Trans i18nKey="global_organization_details" />
                        )}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {this.state.orgdata.length > 1 ||
                      this.props.currentUser.isOperator == 1 ? (
                        <FilterableList
                          dataurl="/organization/"
                          name="organizationName"
                          secondary=""
                          iconColour={this.state.organizationColourTheme}
                          iconSVG={organizationSVG}
                          onItemSelected={this.organizationSelected}
                          organization={this.state.organization}
                          dragStart={this.dragStart}
                          dragEnd={this.dragEnd}
                          addItem={
                            this.props.currentUser.isOperator == 1 &&
                            this.openOrganizationDialog
                          }
                          editItem={this.editOrganization}
                          needsUpdate={this.state.organizationNeedsUpdate}
                          onUpdate={() => {
                            this.setState({ organizationNeedsUpdate: false });
                          }}
                        />
                      ) : (
                        <div>
                          <Typography className={classes.heading}>
                            {this.state.organization.organizationName}
                          </Typography>
                        </div>
                      )}
                    </AccordionDetails>
                  </Accordion>
                  <Accordion
                    key="topic"
                    className={classes.expansionPanel}
                    expanded={this.state.expandedPanel === "topicSelection"}
                    onChange={this.handlePanelChange("topicSelection")}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <div className={classes.panelSummaryIcon}>
                        <svg height="24px" width="24px">
                          <path
                            fill={this.state.topicColourTheme}
                            d={topicSVG}
                          />
                        </svg>
                      </div>
                      <Typography className={classes.heading}>
                        <Trans i18nKey="global_topic_plural" />
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {this.state.organization ? (
                        <FilterableList
                          dataurl="/topic/"
                          filterElement={"FilterTopics"}
                          name="topicName"
                          getSecondaryInfo={this.getTopicSecondaryInfo}
                          isItemEnabled={this.isTopicItemEnabled}
                          iconColour={this.state.topicColourTheme}
                          iconColourDisabled={this.state.disabledColourTheme}
                          iconSVG={topicSVG}
                          onItemSelected={this.topicSelected}
                          organization={this.state.organization}
                          dragStart={this.dragStart}
                          dragEnd={this.dragEnd}
                          addItem={this.openAddTopicDialog}
                          editItem={this.editTopic}
                          needsUpdate={this.state.topicNeedsUpdate}
                          onUpdate={() => {
                            this.setState({ topicNeedsUpdate: false });
                          }}
                        />
                      ) : (
                        <></>
                      )}
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    key="team"
                    className={classes.expansionPanel}
                    expanded={this.state.expandedPanel === "teamSelection"}
                    onChange={this.handlePanelChange("teamSelection")}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <div className={classes.panelSummaryIcon}>
                        <svg height="24px" width="24px">
                          <path fill={this.state.teamColourTheme} d={teamSVG} />
                        </svg>
                      </div>
                      <Typography className={classes.heading}>
                        <Trans i18nKey="global_team_plural" />
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {this.state.organization ? (
                        <FilterableList
                          dataurl="/team/"
                          filterElement={"FilterTeams"}
                          name="teamName"
                          getSecondaryInfo={this.getTeamSecondaryInfo}
                          isItemEnabled={this.isTeamItemEnabled}
                          iconColour={this.state.teamColourTheme}
                          iconColourDisabled={this.state.disabledColourTheme}
                          iconSVG={teamSVG}
                          onItemSelected={this.teamSelected}
                          organization={this.state.organization}
                          dragStart={this.dragStart}
                          dragEnd={this.dragEnd}
                          addItem={this.openAddTeamDialog}
                          editItem={this.editTeam}
                          needsUpdate={this.state.teamNeedsUpdate}
                          onUpdate={() => {
                            this.setState({ teamNeedsUpdate: false });
                          }}
                        />
                      ) : (
                        <></>
                      )}
                    </AccordionDetails>
                  </Accordion>
                </>
              )}
            </Drawer>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, element) => ({
  message: state.websocket.message,
  currentUser: state.user.currentUser,
  licence: state.setting.licence,
});

//export default ((withRouter(withTranslation()(withTheme(withStyles(styles)(TaxonomyMaintenance))))))
export default withRouter(
  connect(
  mapStateToProps,
  null
  )(withTheme(withStyles(styles)(TaxonomyMaintenance)))
);
